import { CodebookModel } from 'app/shared/model/shared.model';

export interface ChamberMemberOverviewRow {
  idChamberMember: number;
  authorizationNumber: string;
  chamber: string;
  firstName: string;
  lastName: string;
  title: string;
  companyName: string;
  companyAddress: string;
}

export interface ChamberMemberOverviewFilterModel {
  chamber: CodebookModel[];
  chamberMember: CodebookModel[];
  oib: string;
  firstName: string;
  lastName: string;
}

export const initialChamberMemberOverviewFilterModel: ChamberMemberOverviewFilterModel = {
  chamber: [],
  chamberMember: [],
  oib: '',
  firstName: '',
  lastName: ''
}
